import React from 'react';
import { connectionsDetailsLabels } from '../../../../../../constants/connections-labels.constants';
import DefaultButton from '../../../../../global/default-button/default-button';
import { FormattedMessage } from 'react-intl';
import { JOIN_AS_ATTENDEE } from '../../../_connections/connections.texts';
import TextWithCopyBtn from '../_text-with-copy-btn/text-with-copy-btn';
import { BaseConnectionDetailsPopoverContentProps } from './types';


export const VeracastConnectionDetailsPopoverContent = (props: BaseConnectionDetailsPopoverContentProps): JSX.Element => {
    const { connection, onLinkClick, onCopyBtnClick } = props;
    const {
        type,
        cancelled,
        connectionLink,
        veracastEventID,
        clientAppLink
    } = connection;

    const labels = connectionsDetailsLabels();

    return (
        <>
            <div className='connection-list__header'>
                <DefaultButton
                    className='small-button silver-button'
                    disabled={!connectionLink || cancelled}
                    text={<FormattedMessage {...JOIN_AS_ATTENDEE} />}
                    onClick={() => onLinkClick(connectionLink)}
                />
            </div>
            <div className='connection-list__field'>{type} {labels.VERACAST_EVENT_ID()}:<br />
                <TextWithCopyBtn message={veracastEventID} handleCopyClick={onCopyBtnClick} />
            </div>
            {connectionLink && <div className='connection-list__field'>{type} {labels.VERACAST_EVENT_URL()}:<br />
                <TextWithCopyBtn message={connectionLink} handleCopyClick={onCopyBtnClick} />
            </div>}
            {clientAppLink && <div className='connection-list__field'>{labels.CLIENT_APP_LINK()}:<br />
                <TextWithCopyBtn message={clientAppLink} handleCopyClick={onCopyBtnClick} />
            </div>}
        </>
    );
};
